export function normalizeProjectCrews(projectCrews: unknown): string[] {
  return Array.isArray(projectCrews)
    ? projectCrews
      .filter((projectCrew): projectCrew is string => typeof projectCrew === 'string')
      .map((projectCrew) => projectCrew.trim())
      .filter(Boolean)
    : [];
}
